import BigNumber from 'bignumber.js'

import { Network } from '@root/entities/network'
import { PairAddress } from '@root/entities/pair'

import type { PoolHolderChartUpdate as PoolHolderChartUpdatesDto } from '@blade/blockchain-types'
import type { TypeHelper } from '@blade/std-lib'

type PoolHolderChartUpdateDto = NonNullable<
  PoolHolderChartUpdatesDto['holdersCount']
>

export interface PoolHolderChartsUpdate {
  holdersCount?: PoolHolderChartUpdate | undefined
  top10HoldersPercentage?: PoolHolderChartUpdate | undefined
  insidersHolding?: PoolHolderChartUpdate | undefined
  bundlersHolding?: PoolHolderChartUpdate | undefined
  snipersHolding?: PoolHolderChartUpdate | undefined
  network: Network.Network
  pairAddress: PairAddress
}

export interface PoolHolderChartUpdate
  extends TypeHelper.OverrideKeys<
    PoolHolderChartUpdateDto,
    {
      timestamp: Date
      value: BigNumber
    }
  > {}

export const fromDto = (
  dto: PoolHolderChartUpdatesDto,
): PoolHolderChartsUpdate => {
  return {
    network: Network.fromSupportedNetwork(dto.network),
    pairAddress: PairAddress(dto.pairAddress),
    holdersCount: dto.holdersCount
      ? chartUpdateFromDto(dto.holdersCount)
      : undefined,
    insidersHolding: dto.insidersHolding
      ? chartUpdateFromDto(dto.insidersHolding)
      : undefined,
    top10HoldersPercentage: dto.top10HoldersPercentage
      ? chartUpdateFromDto(dto.top10HoldersPercentage)
      : undefined,
    bundlersHolding: dto.bundlersHolding
      ? chartUpdateFromDto(dto.bundlersHolding)
      : undefined,
    snipersHolding: dto.snipersHolding
      ? chartUpdateFromDto(dto.snipersHolding)
      : undefined,
  }
}

const chartUpdateFromDto = (
  dto: PoolHolderChartUpdateDto,
): PoolHolderChartUpdate => {
  return {
    timestamp: new Date(dto.timestamp),
    value: BigNumber(dto.value),
  }
}
